import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
import { SUB_APPS as SALES_ANALYTICS_LIB_SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { getHybridSRVSubAppTabs } from 'sales-analytics-lib/utils/report-hybrid-srv-sub-app-data';
import { templatesBySubAppKey
// @ts-expect-error Untyped import
} from 'sales-analytics-lib/utils/get-report-config';
import { getGatesAndScopes } from '../selectors/gatesSelector';
// @ts-expect-error Untyped import
import { getAllCollectionReports } from '../config/analyticTools';
import { selectReportCollectionTemplatesByKey } from '../redux/reportCollectionTemplates';
const isSalesAnalyticsLibSubApp = itemKey => Object.values(SALES_ANALYTICS_LIB_SUB_APPS).includes(itemKey);
const getHybridConfigKeyData = (subAppKey, gates, scopes) => {
  const tabs = getHybridSRVSubAppTabs(subAppKey, scopes, gates);
  return tabs.map(tab => ({
    tab,
    configKey: tab
  }));
};
const getAllTemplatesForSubAppTabs = (subAppKey, templatesByKey, suiteNavData, gates, scopes) => {
  const configKeyData = getHybridConfigKeyData(subAppKey, gates, scopes);
  return configKeyData.reduce((memo, {
    tab,
    configKey
  }) => {
    const templateKey = templatesBySubAppKey.get(configKey);
    const template = templateKey && templatesByKey.get(templateKey);
    if (template) {
      memo.push(template.set('suiteNavData', ImmutableMap(Object.assign({}, suiteNavData, {
        navItemId: subAppKey,
        tabId: tab
      }))));
    }
    return memo;
  }, []);
};
export const useSuiteTemplates = suiteId => {
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  const templatesByKey = useSelector(selectReportCollectionTemplatesByKey);
  return useMemo(() => {
    const suiteItems = getAllCollectionReports(suiteId, gates, scopes);
    return suiteItems.reduce((memo, {
      report: itemKey,
      parentId
    }) => {
      // suite item is a hybrid sub app & we need to get the reports for the tabs under it
      if (isSalesAnalyticsLibSubApp(itemKey)) {
        const tabTemplates = getAllTemplatesForSubAppTabs(itemKey, templatesByKey, {
          suiteId,
          subSuiteId: parentId
        }, gates, scopes);
        memo.push(...tabTemplates);
      }

      // suite item is a single template
      else {
        const template = templatesByKey.get(itemKey);
        if (template) {
          memo.push(template.set('suiteNavData', ImmutableMap({
            suiteId,
            subSuiteId: parentId,
            navItemId: itemKey
          })));
        }
      }
      return memo;
    }, []);
  }, [gates, scopes, suiteId, templatesByKey]);
};